import { fetchJSONWithTimeout } from '@noths/polaris-client-utils';
import getConfig from 'next/config';

import type { RarDataAPIResponse } from 'src/services/rar-data-api/types/RarDataAPIResponse';
import type { NextConfig } from 'src/types/nextConfig';

const { publicRuntimeConfig } = getConfig() as NextConfig;

const RAR_DATA_API_URL_PUBLIC = publicRuntimeConfig.endpoints.rarDataPublic;

// Without a timeout fetchJSONWithTimeout skips the abort entirely, leaving the
// browser holding the connection open indefinitely if rar-data-api stalls.
// Reviews are below the fold and degrade gracefully, so bound them generously.
const CLIENT_TIMEOUT_MS = 5000;

export const fetchProductReviews = async (
  productCode: number,
  { page = 1, perPage = 3 }: { page?: number; perPage?: number } = {},
): Promise<RarDataAPIResponse> => {
  const requestUrl = new URL(`${RAR_DATA_API_URL_PUBLIC}${productCode}`);

  requestUrl.searchParams.set('page', String(page));
  requestUrl.searchParams.set('perPage', String(perPage));

  const response = await fetchJSONWithTimeout(requestUrl.toString(), {
    timeout: CLIENT_TIMEOUT_MS,
  });

  return response.json();
};
